// src/context/NotificationContext.js (was ToastContext.js)
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("warning"); // default to orange
  const [isVisible, setIsVisible] = useState(false);
  const [icon, setIcon] = useState("bi-check-circle-fill");
  const [pulse, setPulse] = useState(0);

  // Timer to automatically hide the notification
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000); // Hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  const showNotification = useCallback((msg, variant = "warning") => {
    setIsVisible(false);
    setMessage(msg);
    setVariant(variant);

    // Set icon based on variant
    if (variant === "success") setIcon("bi-check-circle-fill");
    else if (variant === "danger") setIcon("bi-exclamation-triangle-fill");
    else setIcon("bi-info-circle-fill"); // Default/warning icon

    setPulse((value) => value + 1);
    setIsVisible(true);
  }, []);

  const value = { showNotification };

  return (
    <NotificationContext.Provider value={value}>
      {children}

      {/* --- NEW: Custom Notification Bar Component --- */}
      <div
        key={pulse}
        className={`global-notification-bar ${variant} ${
          isVisible ? "show" : ""
        }`}
      >
        <i className={`bi ${icon}`}></i>
        <span>{message}</span>
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
